import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import ToggleField from '../app-main/components/reduxForms/fields/ToggleField/ToggleField';
import { booleanSwitch } from '../app-event-questions/data/utils';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import TextAreaField from '../shared-components/reduxForms/fields/TextAreaField/TextAreaField';
import NumberField from '../shared-components/reduxForms/fields/NumberField/NumberField';
import { QuestionFilled } from '../shared-components/icons';
import { OverlayTrigger } from 'react-bootstrap';
import Popover from 'react-bootstrap/lib/Popover';
import { isBoolean, isString } from 'lodash';
import { miscEventFaqDefinitions } from '../shared-components/faq/data/eventFaqDefinition';

const ToggleFieldRow = ({
  label,
  subheader,
  fieldName,
  hasQuantity,
  hasDescription,
  tooltip,
  placeholder,
  intl,
  onChange,
  onBlur,
  labelHasAsterisk
}) => (
  <>
    <div key={fieldName} className="flex space-between middle">
      <div className="flex-basis-50">
        <div>{labelHasAsterisk ? `${intl.formatMessage(label)}*` : `${intl.formatMessage(label)}` }</div>
        {
          subheader &&
          <div className="text-small text-gray-dark">{intl.formatMessage(subheader)}</div>
        }
      </div>
      <div>
        <Field
          name={fieldName}
          component={ToggleField}
          onChange={onChange}
          format={(value) => {
            if (isBoolean(value)) return value ? 'true' : 'false';
            if (isString(value)) return value;
            return 'false';
          }}
          firstOption={
            {
              id: `${fieldName}_true`,
              value: 'true',
              label: intl.formatMessage(booleanSwitch.yes)
            }}
          secondOption={
            {
              id: `${fieldName}_false`,
              value: 'false',
              label: intl.formatMessage(booleanSwitch.no)
            }}
        />
      </div>
    </div>
    {
      hasQuantity &&
      <div className="margin-lg-top flex space-between middle">
        <div className="flex middle">
          <FormattedMessage
            id="hosting.event_form.quantity"
            defaultMessage="Quantity"
          />
          {
            tooltip &&
            <div className="margin-sm-left">
              <OverlayTrigger
                trigger="click"
                placement="top"
                rootClose
                overlay={
                  <Popover
                    id="popover-positioned-top"
                    style={{ zIndex: 1029, borderRadius: '2px' }}
                    className="white-bg text-gray-darker"
                  >
                    {intl.formatMessage(tooltip)}
                  </Popover>
                }
              >
                <div role="button" className="flex">
                  <QuestionFilled style={{ color: '#AEAFBD' }}/>
                </div>
              </OverlayTrigger>
            </div>
          }
        </div>
        <div>
          <Field
            name={`${fieldName}_quantity`}
            attributes={{ 'data-testing-id': fieldName }}
            component={NumberField}
            placeholder={0}
            onBlur={onBlur}

          />
        </div>
      </div>
    }
    {
      hasDescription &&
      <div className="margin-lg-top">
        <Field
          name={`${fieldName}_description`}
          component={TextAreaField}
          attributes={{
            'data-testing-id': fieldName
          }}
          placeholder={
            intl.formatMessage(placeholder || miscEventFaqDefinitions.text_area_placeholder)
          }
          height={placeholder ? 120 : 64}
          maxLength={1000}
          onBlur={onBlur}
        />
      </div>
    }
  </>
);

ToggleFieldRow.propTypes = {
  label: PropTypes.string,
  fieldName: PropTypes.string,
  hasQuantity: PropTypes.bool,
  hasDescription: PropTypes.bool,
  tooltip: PropTypes.element,
  placeholder: PropTypes.string,
  intl: intlShape,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  subheader: PropTypes.string,
  labelHasAsterisk: PropTypes.bool
};

export default injectIntl(ToggleFieldRow);
